// src/components/layouts/PublicLayout.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

import { AppShell } from "../appShell";
import { Header } from "./Header";
import { Footer } from "../Footer";
import { ToastProvider } from "../toastProvide";

// ✅ Usa tu barra pública real (ajusta el import/nombre)
import { Nav } from "./Nav"; 
// o: import { NavigationBarPublic as PublicNav } from "./NavPublic";
// o: import { NavigationBar } from "./Nav"; (si reutilizas la misma, pero con items públicos)

export const PublicLayout = () => {
  const { auth, loading } = useAuth();
  const location = useLocation();

  // =========================
  // Guardas
  // =========================
  if (loading) return <div>Cargando...</div>;
  if (auth?.id) return <Navigate to="/app/inicio" replace state={{ from: location }} />;

  // =========================
  // Render
  // =========================
  return (
    <ToastProvider>
      <AppShell header={<Header />} nav={<Nav />} footer={<Footer />}>
        <Outlet />
      </AppShell>
    </ToastProvider>
  );
};
